'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenItemPreload = function (_React$Component) {
  (0, _inherits3.default)(FullscreenItemPreload, _React$Component);

  function FullscreenItemPreload() {
    (0, _classCallCheck3.default)(this, FullscreenItemPreload);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenItemPreload.__proto__ || (0, _getPrototypeOf2.default)(FullscreenItemPreload)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenItemPreload, [{
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var idx = this.props.item.idx;

      var innerStyle = {
        width: item.width + 'px',
        height: item.height + 'px',
        backgroundColor: item.bgColor,
        objectFit: 'contain'
      };

      return item.preload_img && (item.isImage || item.isVideo && !this.props.loaded) ? _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-preload fullscreen-preload-' + idx,
          key: 'preload_container'
        },
        _react2.default.createElement('img', {
          className: 'fullscreen-item fullscreen-item-preload',
          src: item.preload_img,
          style: innerStyle,
          key: 'preload'
        }),
        this.props.loaded ? false : _react2.default.createElement('div', { className: 'pro-circle-preloader' })
      ) : _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-preload fullscreen-preload-' + idx,
          key: 'preload_container'
        },
        _react2.default.createElement('div', {
          className: 'fullscreen-item fullscreen-item-preload',
          style: innerStyle,
          key: 'preload'
        })
      );
    }
  }]);
  return FullscreenItemPreload;
}(_react2.default.Component);

exports.default = FullscreenItemPreload;